// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N2Lm","col":"styles_col__33j1c"};